module.exports = __webpack_public_path__ + "static/media/op_stoeltjes_voor_kachel.6882bba5.jpg";